// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eQ7v","select":"styles_select__1ClKB"};